import ConfigList from 'Model/ConfigList'
import { branch } from 'Model/constants'

class MemberKeys extends ConfigList
  @className = 'MemberKeys'

  constructor: ->
    super('memberKeys')

  @load: ->
    super('memberKeys', @)

export default MemberKeys
